import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
import Layout from '@/views/layout/layout'
const routes = [
	{ path: '/login', component: () => import('@/views/login/index') },
	{ path: '/404', component: () => import('@/views/404') },
	{
		path: '/',
		component: Layout,
		redirect: '/home',
		name: 'home',
		children: [
			{
				path: '/home',
				component: () => import('@/views/Home.vue'),
				meta: {
					title: '首页'
				}
			}
		]
	},
	{
		path: '/goods/detail',
		component: () => import('@/views/goods/detail/index')
	},
	{
		path: '/goods',
		component: Layout,
		name: 'goods',
		meta: { title: '商品管理' },
		redirect: '/goods/index',
		children: [
			{
				meta: { title: '供应链商品库' },
				path: '/goods/index',
				component: () => import('@/views/goods/list/index')
			},

			{
				meta: { title: '商品分类管理' },
				path: '/goods/classifyList',
				component: () => import('@/views/goods/classify/index')
			},
			// {
			// 	meta: { title: '商品分类管理', parentPath: '/goods/classifyList' },
			// 	path: '/goods/classifyDetail',
			// 	component: () => import('@/views/goods/classify/detail')
			// },
			{
				meta: { title: '商品来源管理' },
				path: '/goods/source',
				component: () => import('@/views/goods/source/index')
			},
			{
				meta: { title: '运费模版设置' },
				path: '/goods/freightTemplate',
				component: () => import('@/views/goods/freightTemplate/index')
			}
		]
	},
	{
		path: '/orders',
		component: Layout,
		redirect: '/orders/list',
		name: 'orders',
		meta: { title: '订单管理' },
		children: [
			{
				meta: { title: '供应链订单' },
				path: '/orders/list',
				component: () => import('@/views/orders/index')
			},
			{
				meta: { title: '供应链订单详情', parentPath: '/orders/list' },
				path: '/orders/detail',
				component: () => import('@/views/orders/detail')
			},
			{
				meta: { title: '自产自销订单' },
				path: '/orders/ownList',
				component: () => import('@/views/orders/ownList')
			},
			{
				meta: { title: '自产自销订单详情', parentPath: '/orders/ownList' },
				path: '/orders/ownDetail',
				component: () => import('@/views/orders/ownDetail')
			},
			{
				meta: { title: '供应链维权订单' },
				path: '/orders/safeguard',
				component: () => import('@/views/orders/safeguard')
			},
			{
				meta: { title: '维权订单详情', parentPath: '/orders/safeguard' },
				path: '/orders/guardDetail',
				component: () => import('@/views/orders/guardDetail')
			},
			{
				meta: { title: '未发货订单' },
				path: '/orders/unshipped',
				component: () => import('@/views/orders/unshipped')
			},
			{
				meta: { title: '未发货订单详情', parentPath: '/orders/unshipped' },
				path: '/orders/unshippedDetail',
				component: () => import('@/views/orders/unshippedDetail')
			}
		]
	},
	{
		path: '/user',
		component: Layout,
		redirect: '/user/list',
		name: 'user',
		meta: { title: '分销商账号管理' },
		children: [
			{
				meta: { title: '分销商渠道列表' },
				path: '/user/list',
				component: () => import('@/views/user/index')
			},
			{
				meta: { title: '分销商扣费记录' },
				path: '/user/deductionRecord',
				component: () => import('@/views/user/deductionRecord')
			},
			{
				meta: { title: '分销商充值记录' },
				path: '/user/rechargeRecord',
				component: () => import('@/views/user/rechargeRecord')
			}
		]
	},
	{
		path: '/settings',
		component: Layout,
		redirect: '/settings/accounts',
		name: 'settings',
		meta: { title: '系统设置' },
		children: [
			{
				meta: { title: '系统接口设置' },
				path: 'api',
				component: () => import('@/views/settings/api/index')
			},
			{
				meta: { title: '操作账号管理' },
				path: 'accounts',
				component: () => import('@/views/settings/accounts/index')
			}
		]
	}
]

export default new VueRouter({
	routes
})
